export type TPageKey =
  | 'home'
  | 'contactUs'
  | 'faq'
  | 'features'
  | 'generateOgImage'
  | 'ogImage'
  | 'pricing'
  | 'privacy'
  | 'releases'
  //| 'support'
  | 'terms'
//| 'themes'
//| 'tools'

export type TPagePath =
  | '/'
  | '/contact-us'
  | '/faq'
  | '/features'
  | '/generate-og-image'
  | '/og-image'
  | '/pricing'
  | '/privacy-policy'
  | '/releases'
  // | '/support'
  // | '/support-form'
  | '/terms-of-use'
// | '/themes'
// | '/tools'

export const pagePaths: Record<TPageKey, TPagePath> = Object.freeze({
  home: '/',
  faq: '/faq',
  contactUs: '/contact-us',
  features: '/features',
  generateOgImage: '/generate-og-image',
  ogImage: '/og-image',
  pricing: '/pricing',
  privacy: '/privacy-policy',
  releases: '/releases',
  // reports: '/reports',
  // support: '/support-form',
  terms: '/terms-of-use',
  // themes: '/themes',
  // tools: '/tools',
} as const)

export const pathToPageKey: Record<TPagePath, TPageKey> = Object.freeze({
  '/': 'home',
  '/contact': 'contactUs',
  '/contact-us': 'contactUs',
  '/features': 'features',
  '/features/': 'features',
  '/faq': 'faq',
  '/faq/': 'faq',
  '/og-image': 'ogImage',
  '/og-image/': 'ogImage',
  '/generate-og-image': 'generateOgImage',
  '/generate-og-image/': 'generateOgImage',
  '/pricing': 'pricing',
  '/pricing/': 'pricing',
  '/privacy-policy': 'privacy',
  '/privacy-policy/': 'privacy',
  '/releases': 'releases',
  '/releases/': 'releases',
  // '/reports': 'reports',
  // '/reports/': 'reports',
  // '/support-form': 'support',
  // '/support-form/': 'support',
  // '/support': 'support',
  // '/support/': 'support',
  '/terms-of-use': 'terms',
  '/terms-of-use/': 'terms',
  // '/themes': 'themes',
  // '/themes/': 'themes',
  // '/tools': 'tools',
  // '/tools/': 'tools',
} as const)
